module.exports = {"id":"dp2_1l3q1","text":"Interacting Through Digital Technologies","instructions":"Why should digital communication be adapted to different contexts?","multiselect":false,"questionType":"PickOne","random":true,"options":[{"id":"dp2_1l3q1-a1","text":"Different contexts require different approaches","score":3.7},{"id":"dp2_1l3q1-a2","text":"Digital tools work the same everywhere","score":1.3},{"id":"dp2_1l3q1-a3","text":"Context has no effect on meaning","score":1.3}],"groupTitle":"Digital Profiler Knowledge Matrix","category":"2.1"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat2.1/l3q1.json
// module id = 992
// module chunks = 41